import { api } from './api';
import { ExerciseType, ExerciseTypeCreateInput, ExerciseTypeUpdateInput } from '../types/exerciseType';

export const DEFAULT_EXERCISE_TYPES: ExerciseType[] = [
  { id: 1, key: 'cyber', name: 'Cyber Attack', icon: '🔒', category: 'cybersecurity', display_order: 1, is_active: true },
  { id: 2, key: 'ransomware', name: 'Ransomware Attack', icon: '🛡️', category: 'cybersecurity', display_order: 2, is_active: true },
  { id: 3, key: 'phishing', name: 'Phishing Attack', icon: '📧', category: 'cybersecurity', display_order: 3, is_active: true },
  { id: 4, key: 'business_email_compromise', name: 'Business Email Compromise', icon: '✉️', category: 'cybersecurity', display_order: 4, is_active: true },
  { id: 5, key: 'ddos', name: 'DDoS Attack', icon: '🌐', category: 'cybersecurity', display_order: 5, is_active: true },
  { id: 6, key: 'supply_chain', name: 'Supply Chain Attack', icon: '🔗', category: 'cybersecurity', display_order: 6, is_active: true },
  { id: 7, key: 'fire', name: 'Fire Emergency', icon: '🔥', category: 'natural_disaster', display_order: 7, is_active: true },
  { id: 8, key: 'earthquake', name: 'Earthquake', icon: '🌋', category: 'natural_disaster', display_order: 8, is_active: true },
  { id: 9, key: 'flood', name: 'Flood Hazard', icon: '🌊', category: 'natural_disaster', display_order: 9, is_active: true },
  { id: 10, key: 'power_outage', name: 'Power & Utility Outage', icon: '⚡', category: 'business_continuity', display_order: 10, is_active: true },
  { id: 11, key: 'pandemic', name: 'Pandemic & Health Crisis', icon: '🏥', category: 'business_continuity', display_order: 11, is_active: true },
  { id: 12, key: 'active_shooter', name: 'Active Threat & Physical Security', icon: '🚨', category: 'physical_security', display_order: 12, is_active: true },
  { id: 13, key: 'other', name: 'Other Scenario', icon: '📋', category: 'general', display_order: 99, is_active: true },
];

class ExerciseTypeService {
  async getExerciseTypes(includeInactive = false): Promise<ExerciseType[]> {
    try {
      const response = await api.get(`/v1/tabletop-exercises/exercise-types?include_inactive=${includeInactive}`);
      return Array.isArray(response?.data) && response.data.length > 0 ? response.data : DEFAULT_EXERCISE_TYPES;
    } catch (err) {
      console.warn('Falling back to default exercise types:', err);
      return DEFAULT_EXERCISE_TYPES;
    }
  }

  async getAdminExerciseTypes(includeInactive = true): Promise<ExerciseType[]> {
    try {
      const response = await api.get(`/v1/admin/exercise-types?include_inactive=${includeInactive}`);
      return Array.isArray(response?.data) ? response.data : DEFAULT_EXERCISE_TYPES;
    } catch (err) {
      console.warn('Falling back to default exercise types for admin:', err);
      return DEFAULT_EXERCISE_TYPES;
    }
  }

  async createExerciseType(data: ExerciseTypeCreateInput): Promise<ExerciseType> {
    const response = await api.post('/v1/admin/exercise-types', data);
    return response.data;
  }

  async updateExerciseType(idOrKey: string | number, data: ExerciseTypeUpdateInput): Promise<ExerciseType> {
    const response = await api.put(`/v1/admin/exercise-types/${idOrKey}`, data);
    return response.data;
  }

  async deleteExerciseType(idOrKey: string | number): Promise<{ message: string; action: 'deleted' | 'deactivated' }> {
    const response = await api.delete(`/v1/admin/exercise-types/${idOrKey}`);
    return response.data;
  }
}

export const exerciseTypeService = new ExerciseTypeService();
